import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpDropdownTabsComponent from './adpDropdownTabs.component';

let adpDropdownTabsModule = angular.module('adpDropdownTabs', [
  uiRouter
])

.component('adpDropdownTabs', adpDropdownTabsComponent)

.name;

export default adpDropdownTabsModule;



// WEBPACK FOOTER //
// ./src/app/components/adpDropdownTabs/adpDropdownTabs.js